import { Column, Entity, Index, OneToMany } from 'typeorm';
import { ApiConfigurationRbacActionEntity } from './api-configuration-rbac-action.entity';
import { BaseEntity } from './base.entity';
import { RbacActionObjectEntity } from './rbac-action-object.entity';
import { RbacActionRoleEntity } from './rbac-action-role.entity';
import { RbacActionUserEntity } from './rbac-action-user.entity';

@Index('_name', ['name'], { unique: true })
@Entity('_rbac_action')
export class RbacActionEntity extends BaseEntity {
	@Column('varchar', { name: '_name', unique: true, length: 255 })
	public name!: string;

	@Column('varchar', { name: '_label', nullable: true, length: 255 })
	public label!: string | null;

	@OneToMany(
		() => ApiConfigurationRbacActionEntity,
		(apiConfigurationRbacAction) => apiConfigurationRbacAction.fkRbacAction,
		{},
	)
	public apiConfigurationRbacActions!: Array<ApiConfigurationRbacActionEntity>;

	@OneToMany(
		() => RbacActionObjectEntity,
		(rbacActionObject) => rbacActionObject.fkRbacAction,
		{},
	)
	public rbacActionObjects!: Array<RbacActionObjectEntity>;

	@OneToMany(
		() => RbacActionRoleEntity,
		(rbacActionRole) => rbacActionRole.fkRbacAction,
		{},
	)
	public rbacActionRoles!: Array<RbacActionRoleEntity>;

	@OneToMany(
		() => RbacActionUserEntity,
		(rbacActionUser) => rbacActionUser.fkRbacAction,
		{},
	)
	public rbacActionUsers!: Array<RbacActionUserEntity>;
}
